import { FC, RefObject } from 'react';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { FormHandles } from '@unform/core';
import Select from 'src/components/Form/Select';
import { Item } from 'src/components/Form/Select/interfaces';
import TextField from 'src/components/Form/TextField';

interface FilterProps {
  formRef?: RefObject<FormHandles>;
}

const visibleItems: Item[] = [
  { key: 1, label: 'Sim', value: 1 },
  { key: 2, label: 'Não', value: 0 },
];

const Filters: FC<FilterProps> = () => {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <TextField name="partner_name" label="Nome do Parceiro" size="small" />
      </Grid>

      <Grid item xs={12}>
        <TextField name="service_name" label="Nome do Serviço" size="small" />
      </Grid>

      {/* <Grid item xs={12}>
        <DatePickerOperator
          name="start_at"
          label="Ínicio"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid>

      <Grid item xs={12}>
        <DatePickerOperator
          name="end_at"
          label="Fim"
          datePickerProps={{ size: 'small' }}
          selectOperatorProps={{ size: 'small' }}
        />
      </Grid> */}

      <Grid item xs={12}>
        <Select
          name="campaign_visible"
          label="Visível Hoje"
          items={visibleItems}
          size="small"
        />
      </Grid>
    </>
  );
};

export default Filters;
